export var FundChartOptionValue;
(function (FundChartOptionValue) {
    FundChartOptionValue["DISPLAY_DATE_RANGE"] = "displayDateRange";
    FundChartOptionValue["LEGEND_ON_CHART"] = "legendOnChart";
    FundChartOptionValue["QUOTE_LEGEND"] = "quoteLegend";
    FundChartOptionValue["DATA_IN_LEGEND"] = "dataInLegend";
    FundChartOptionValue["SHOW_CUSTOM_COLORS"] = "useCustomColors";
    FundChartOptionValue["SHOW_DATA_SOURCE"] = "source";
    FundChartOptionValue["SHOW_FORWARD_ESTIMATES"] = "useEstimates";
    FundChartOptionValue["NAME_IN_LEGEND"] = "nameInLegend";
    FundChartOptionValue["SHOW_UNITS_IN_LEGEND"] = "units";
    FundChartOptionValue["SHOW_US_RECESSIONS"] = "recessions";
    FundChartOptionValue["USE_LOG_SCALE"] = "scaleType";
    FundChartOptionValue["VALUE_FLAGS"] = "valueFlags";
    FundChartOptionValue["SHOW_PERFORMANCE_DISCLOSURE"] = "performanceDisclosure";
    FundChartOptionValue["CONVERT_CURRENCY"] = "convertCurrency";
    FundChartOptionValue["CURRENCY"] = "currency";
})(FundChartOptionValue || (FundChartOptionValue = {}));
export var FundChartSeriesType;
(function (FundChartSeriesType) {
    FundChartSeriesType["security"] = "security";
    FundChartSeriesType["securityList"] = "security_list";
})(FundChartSeriesType || (FundChartSeriesType = {}));
export var CorrelationType;
(function (CorrelationType) {
    CorrelationType["RATIO"] = "ratio";
    CorrelationType["SPREAD"] = "spread";
    CorrelationType["CORRELATION"] = "correlation";
})(CorrelationType || (CorrelationType = {}));
export var FundChartAnnotationName;
(function (FundChartAnnotationName) {
    // text annotation
    FundChartAnnotationName["TEXT"] = "Text";
    // shape annotations
    FundChartAnnotationName["CIRCLE"] = "Circle";
    FundChartAnnotationName["RECTANGLE"] = "Rectangle";
    // line annotations
    FundChartAnnotationName["TREND_SEGMENT"] = "Trend Segment";
    FundChartAnnotationName["ARROW_SEGMENT"] = "Arrow Segment";
    FundChartAnnotationName["RAY"] = "Ray";
    FundChartAnnotationName["ARROW_RAY"] = "Arrow Ray";
    FundChartAnnotationName["LINE"] = "Line";
    FundChartAnnotationName["ARROW_LINE"] = "Arrow Line";
    FundChartAnnotationName["PARALLEL_CHANNEL"] = "Parallel Channel";
    FundChartAnnotationName["HORIZONTAL_LINE"] = "Horizontal Line";
    FundChartAnnotationName["VERTICAL_LINE"] = "Vertical Line";
})(FundChartAnnotationName || (FundChartAnnotationName = {}));
export var FundChartCursorType;
(function (FundChartCursorType) {
    FundChartCursorType["CURSOR"] = "cursor";
    FundChartCursorType["CROSSHAIR"] = "crosshair";
})(FundChartCursorType || (FundChartCursorType = {}));
export var DataInLegendOption;
(function (DataInLegendOption) {
    DataInLegendOption["VALUE"] = "value";
    DataInLegendOption["ANNUALIZED_VALUE"] = "annualized_value";
    DataInLegendOption["VALUE_AND_ANNUALIZED_VALUE"] = "value_and_annualized_value";
    DataInLegendOption["NONE"] = "none";
})(DataInLegendOption || (DataInLegendOption = {}));
export var ValueFlagOption;
(function (ValueFlagOption) {
    ValueFlagOption["VALUE"] = "value";
    ValueFlagOption["TICKER"] = "ticker";
    ValueFlagOption["VALUE_AND_TICKER"] = "value_and_ticker";
    ValueFlagOption["NONE"] = "none";
})(ValueFlagOption || (ValueFlagOption = {}));
